import './search-results.css';

import 'components/util/num-pager/num-pager';
import 'components/resources/grid/grid';

import 'components/sstk/search/sponsored-results/sponsored-results';
import 'components/sstk/search/justified-search/justified-search';
